import type { PropsWithChildren } from "react";

export default function Label({
	className,
	children,
	htmlFor,
	...props
}: PropsWithChildren<
	{
		htmlFor: string;
		className?: string;
	} & React.LabelHTMLAttributes<HTMLLabelElement>
>) {
	return (
		<label
			htmlFor={htmlFor}
			className={`uppercase inline-block ml-1 mb-1 text-slate-400 tracking-widest text-xs ${className}`}
			{...props}
		>
			{children}
		</label>
	);
}
